import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-iniciar-nuevo',
  templateUrl: './iniciar-nuevo.component.html',
  styleUrls: ['./iniciar-nuevo.component.scss']
})
export class IniciarNuevoComponent implements OnInit {
  enviroment = environment.BASE_URL;
  input;
  public errorMsg:string;

  constructor(private router: Router, private _loginService : LoginService) { }

  ngOnInit(): void {
    this.input = {
      username: '',
      password: ''
    }
  }

  onLogin(){
    this.errorMsg = '';
    this._loginService.loginUser(this.input).subscribe(
      response => {
        this._loginService.guardarToken(response.token);
        this.router.navigate(['elegir-paquete']);
      },
      error =>{
        console.log('error: ', error)
        this.errorMsg = 'No hemos podido iniciar sesión con las credenciales proporcionadas';
      }
    )
  }

}
